<template>
  <div class="full-height d-flex flex-column">
    <pc-header activeIndex="docs"></pc-header>
    <div class="container-fluid h-100" >
      <div class="row">
        <div class="col-12 col-md mt-n4 " style="background-color: gray;">
          <pc-documentation-nav/>

        </div>
        <div class="col-12 col-md-10 mt-4 mt-xl-0" style="min-height: 86vh">
<!--          <div class="mt-4">Documentation section is not available yet.</div>-->
<!--          <div class="mt-4">-->
<!--            Visit <a href="https://github.com/gleb-sevruk/pycrunch-engine" target="_blank">github page</a> for most actual documentation-->
<!--          </div>-->
          <router-view />
        </div>
      </div>

      </div>
    <pc-footer></pc-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import PcHeader from '@/components/pc-header.component'
import PcFooter from '@/views/PcFooter'
import PcDocumentationNav from '../documentation/documentation-nav.component'

export default {
  name: 'home',
  components: {
    PcFooter,
    PcHeader,
    HelloWorld,
    PcDocumentationNav,
  }
}
</script>
<style scoped>
  .full-height {
    min-height: 100vh;
    flex-direction: column;
  }
</style>
